import { IoAddSharp } from "react-icons/io5";
import { Button, Modal, notification } from "antd";
import React, { useState } from "react";
import { renderUserName, roles, subRoles } from "../../../utils/constants";
import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import CustomForm from "../CustomForm";
import { prestationInputs } from "../../../pages/Prestations/PrestationDetail/PrestationDetailForm";
import { http } from "../../../engine/api/http";
import { sendEmailInvitation } from "../../../engine/api/apiRequest";
import { modalApplicantIntervenantInputs } from "./ModalApplicantIntervenantInputs";

export const CreateApplicant = ({
  formRef,
  onCreated,
  name,
  institution,
  opener,
  disabled,
}) => {
  const [open, setOpen] = useState(false);

  const onSubmitForm = async data => {
    try {
      if (name === "applicant") {
        let institutionRef = formRef.current.getFieldValue("institution");

        data.institution = institutionRef;
        data.role = roles.institution;
        data.subRoles = subRoles.institutionDemander; // applicant
      } else {
        data.institution = institution;
      }

      data.customerId = "oseo";

      let url = "";

      if (name === "intervenant") {
        url = "responsables/new";
      } else {
        url = "users/new";
      }

      const create = await http.post(url, data);
      if (create.status === 200) {
        if (create?.data === "Invalid email address") {
          notification.error({
            message: "Cet email est invalide",
          });
        } else {
          onCreated(create?.data._id, create?.data);
          if (name === "applicant") {
            formRef?.current?.setFieldsValue({ [name]: create?.data._id });
          }
          setOpen(false);
          notification.success({
            message: `${
              name === "applicant" ? "Demandeur" : "Responsable"
            } créé avec succès`,
          });
          if (data.invitation === true && name === "applicant") {
            await sendEmailInvitation(create?.data._id);
          }
        }
      }
    } catch (e) {
      if (e?.response?.status === 400) {
        notification.error({
          message: e?.response?.data?.message,
          duration: 5000,
        });
      }
    }
  };

  return (
    <>
      <Modal
        title={
          name === "applicant"
            ? "Ajouter un demandeur"
            : "Ajouter un responsable"
        }
        centered
        open={open}
        onOk={() => setOpen(false)}
        footer={null}
        onCancel={() => setOpen(false)}
        width={1000}
      >
        <CustomForm
          disabled={disabled}
          dataSource={modalApplicantIntervenantInputs({ setOpen, name })}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          wrapperCol={24}
        />
      </Modal>

      {opener === undefined && (
        <Button
          disabled={disabled}
          type={"primary"}
          size={"small"}
          style={{
            justifySelf: "flex-start",
            display: "flex",
          }}
          onClick={() => {
            setOpen(true);
          }}
          icon={
            <IoAddSharp
              style={{
                marginTop: "0px",
              }}
              size={25}
            />
          }
        >
          Ajouter un {name === "applicant" ? "demandeur" : "responsable"}
        </Button>
      )}

      {opener &&
        React.cloneElement(opener, {
          onClick: () => {
            setOpen(true);
          },
        })}
    </>
  );
};
